import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './mission-vision.css';

import missionImage from '../assets/images/mission.jpg';
import visionImage from '../assets/images/vision.jpg';

const MissionVision = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <section className="mission-vision-section">
      <div className="mission-vision-container">

        <div className="mission-vision-row">
          <div className="mission-vision-image" data-aos="fade-right">
            <img src={missionImage} alt="Our Mission" className="mission-vision-img" />
          </div>
          <div className="mission-vision-text" data-aos="fade-left">
            <h3>Our Mission</h3>
            <p>
              Our mission is to deliver instant, transparent, and accessible financial support tailored specifically for salaried individuals facing urgent monetary needs. We are committed to addressing these needs with unwavering empathy, exceptional speed, and continuous innovation—ensuring that when life demands immediate attention, financial barriers do not stand in the way. Through ethical practices, responsible lending, and customer-centric solutions, we strive to empower our clients to overcome financial challenges with confidence and dignity.
            </p>
          </div>
        </div>

        <div className="mission-vision-row reverse">
          <div className="mission-vision-image" data-aos="fade-left">
            <img src={visionImage} alt="Our Vision" className="mission-vision-img" />
          </div>
          <div className="mission-vision-text" data-aos="fade-right">
            <h3>Our Vision</h3>
            <p>
              To be recognized as India’s most trusted and innovative Ultra Short Term Loan platform, delivering swift and transparent financial support through human-centered technology. We envision a future where financial emergencies are seamlessly addressed with speed, clarity, and empathy, redefining lending for the modern salaried generation. Our dedication is to empower every individual with accessible solutions that foster financial confidence and well-being, setting new standards in responsible and inclusive lending.
            </p>
          </div>
        </div>

      </div>
    </section>
  );
};

export default MissionVision;
